import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function MaskedLine({ children, delay = 0, className = "", as: Tag = "span" }) {
  const MotionTag = motion[Tag] || motion.span;
  return (
    <span className={`mask-line ${className}`}>
      <MotionTag
        initial={{ y: "110%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 0.9, delay, ease: EASE }}
        className="block will-change-transform"
      >
        {children}
      </MotionTag>
    </span>
  );
}

export function FadeUp({ children, delay = 0, className = "", y = 28, once = true, ...rest }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-60px" }}
      transition={{ duration: 0.8, delay, ease: EASE }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function SectionTag({ children, dark = false }) {
  return (
    <div
      data-testid="section-tag"
      className={`font-mono text-xs uppercase tracking-[0.22em] flex items-center gap-3 ${
        dark ? "text-safety" : "text-safety"
      }`}
    >
      <span className="inline-block h-px w-8 bg-safety" />
      {children}
    </div>
  );
}

export function StatusPill({ status }) {
  const map = {
    New: "bg-sky-400/15 text-sky-300 border-sky-400/30",
    Reviewed: "bg-indigo-400/15 text-indigo-300 border-indigo-400/30",
    Contacted: "bg-amber-400/15 text-amber-300 border-amber-400/30",
    Qualified: "bg-emerald-400/15 text-emerald-300 border-emerald-400/30",
    "Accepted Pending Payment": "bg-safety/15 text-safety border-safety/40",
    Enrolled: "bg-emerald-500/15 text-emerald-400 border-emerald-500/40",
    "Follow Up Later": "bg-violet-400/15 text-violet-300 border-violet-400/30",
    "Not a Fit": "bg-slate-500/15 text-slate-400 border-slate-500/30",
  };
  return (
    <span
      data-testid={`status-pill-${status.toLowerCase().replace(/\s+/g, "-")}`}
      className={`font-mono text-[11px] uppercase tracking-wider px-2.5 py-1 border ${map[status] || map.New}`}
    >
      {status}
    </span>
  );
}
